<template>
  <div class="docx-viewer">
    <div class="document-content">
      <!-- 使用 iframe 嵌入 Office Online Viewer -->
      <iframe
        :src="viewerUrl"
        class="office-frame"
        frameborder="0"
        @load="onFrameLoad"
        @error="onFrameError">
      </iframe>
      <div v-if="!loaded" class="loading">正在加载文档...</div>
      <div v-if="error" class="error">
        <p>{{ error }}</p>
        <el-button type="primary" size="small" @click="downloadDoc">下载文档</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    docPathKey: {
      type: String,
      required: true,
      default: '1'
    },
    fileName: {
      type: String,
      default: '文档.docx'
    }
  },
  data() {
    return {
      loaded: false,
      error: '',
      docUrl: ''
    };
  },
  computed: {
    viewerUrl() {
      // 使用 Microsoft Office Online Viewer
      const docPath = 'https://andrnd.com/doc/' + this.docPathKey + '.docx';
      this.docUrl = docPath;
      // 使用 Office Online 查看器
      return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(docPath)}`;
    }
  },
  methods: {
    onFrameLoad() {
      this.loaded = true;
      this.error = '';
    },
    onFrameError() {
      this.error = '文档加载失败，请尝试下载后查看';
    },
    downloadDoc() {
      // 下载文档
      const link = document.createElement('a');
      link.href = this.docUrl;
      link.download = this.fileName;
      link.click();
    }
  }
};
</script>

<style scoped>
.docx-viewer {
  width: 100%;
  height: 100%;
  min-height: 600px;
  position: relative;
}

.document-content {
  width: 100%;
  height: 100%;
  position: relative;
}

.office-frame {
  width: 100%;
  height: 600px;
  border: none;
  background: #fff;
}

.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  padding: 40px;
  font-size: 18px;
  color: #666;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  z-index: 10;
}

.error {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  padding: 40px;
  font-size: 16px;
  color: #f56c6c;
  background-color: #fef0f0;
  border: 1px solid #fde2e2;
  border-radius: 8px;
  margin: 20px;
  z-index: 10;
}

.error p {
  margin-bottom: 20px;
}
</style>
